<div class="select-contract-review-dialog">
    <button mat-icon-button class="close-btn" (click)="onCancel()">
      <mat-icon>close</mat-icon>
    </button>
  
    <div class="dialog-header">
      <div class="header-icon">
        <mat-icon>description</mat-icon>
      </div>
      <h2>{{ 'search_form_standardize.dialog_select_contract_review.title' | translate }}</h2>
    </div>
  
    <div class="row search-row">
      <!-- Tên / Mã hợp đồng văn bản -->
      <div class="col-lg-3 col-md-6">
        <mat-form-field class="w-100" style="font-size: 16px;">
          <mat-label>{{ 'search_form_standardize.contract_code_name' | translate }}</mat-label>
          <input
           type="text"
           matInput
           [formControl]="keywordControl"
           (focusout)="keywordControl.setValue((keywordControl.value || '').trim())"
           maxlength="200"
           (keydown.enter)="onSearchClick()"
           autocomplete="off"
          />
          <button
            mat-button
            matSuffix
            *ngIf="keywordControl.value"
            type="button"
            mat-icon-button
            aria-label="Clear"
            (click)="keywordControl.setValue('')"
          >
            <mat-icon>close</mat-icon>
          </button>
        </mat-form-field>
      </div>

      <!-- Loại hợp đồng/văn bản: combobox hỗ trợ gõ tìm kiếm trong dropdown (giống màn standardize) -->
      <div class="col-lg-3 col-md-6">
        <mat-form-field class="w-100" style="font-size: 16px;">
          <mat-label>{{ 'search_form_standardize.contract_type' | translate }}</mat-label>
          <mat-select
            #serviceTypeSelect
            [formControl]="serviceTypeControl"
            (openedChange)="onServiceTypeSelectOpenChange($event)"
            (selectionChange)="onContractTypeChange()"
          >
            <div class="select-search-box" (click)="$event.stopPropagation()">
              <input
                type="text"
                #serviceTypeSearchInput
                class="select-search-input"
                [placeholder]="'common.search_placeholder' | translate"
                [(ngModel)]="serviceTypeSearchText"
                name="serviceTypeSearch"
                [ngModelOptions]="{standalone: true}"
                (input)="onServiceTypeSearchChange()"
                (keydown)="$event.stopPropagation()"
                maxlength="200"
                style="padding-inline: 15px !important;"
              />
            </div>
            <mat-option value="">{{ 'common.all' | translate }}</mat-option>
            <mat-option *ngFor="let opt of filteredServiceTypeOptions | async" [value]="opt.id">
              {{ opt.name }}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>

      <div class="search-btn-col d-flex align-items-end justify-content-end ml-auto">
        <button mat-stroked-button color="primary" type="button" (click)="onSearchClick()" [disabled]="isLoading">
          <mat-icon class="mr-0">search</mat-icon> {{ 'common.search' | translate }}
        </button>
      </div>
    </div>
  
    <p class="note-label" style="font-size: 14px;">
      {{ 'search_form_standardize.dialog_select_contract_review.note' | translate }}
    </p>

    <div class="table-wrapper">
      <table mat-table [dataSource]="dataSource" class="contract-table" style="font-size: 14px !important">
        <ng-container matColumnDef="select">
          <th mat-header-cell *matHeaderCellDef>
            <mat-checkbox [checked]="isAllSelected()" (change)="toggleAll()"></mat-checkbox>
          </th>
          <td mat-cell *matCellDef="let row">
            <mat-checkbox [checked]="isSelected(row)" (change)="toggleRow(row)"></mat-checkbox>
          </td>
          <td mat-footer-cell *matFooterCellDef class="skeleton-footer-cell">
            <span class="skeleton-cell"></span>
          </td>
        </ng-container>
  
        <ng-container matColumnDef="stt">
          <th mat-header-cell *matHeaderCellDef>{{ 'labor_contract_standardize.table_headers.no' | translate }}</th>
          <td mat-cell *matCellDef="let row; let i = index" style="text-align: center;">
            {{ paginate.currentPage * paginate.pageSize + i + 1 }}
          </td>
          <td mat-footer-cell *matFooterCellDef class="skeleton-footer-cell">
            <span class="skeleton-cell"></span>
          </td>
        </ng-container>
  
        <ng-container matColumnDef="name">
          <th mat-header-cell *matHeaderCellDef>{{ 'labor_contract_standardize.table_headers.contract_code_name' | translate }}</th>
          <td mat-cell *matCellDef="let row" [matTooltip]="row.name">{{ row.name }}</td>
          <td mat-footer-cell *matFooterCellDef class="skeleton-footer-cell">
            <span class="skeleton-cell"></span>
          </td>
        </ng-container>
  
        <ng-container matColumnDef="serviceType">
          <th mat-header-cell *matHeaderCellDef>{{ 'labor_contract_standardize.table_headers.contract_type' | translate }}</th>
          <td mat-cell *matCellDef="let row" [matTooltip]="row.serviceTypeName">{{ row.serviceTypeName }}</td>
          <td mat-footer-cell *matFooterCellDef class="skeleton-footer-cell">
            <span class="skeleton-cell"></span>
          </td>
        </ng-container>
  
        <ng-container matColumnDef="allName">
          <th mat-header-cell *matHeaderCellDef>{{ 'labor_contract_standardize.table_headers.signers' | translate }}</th>
          <td mat-cell *matCellDef="let row" [matTooltip]="row.allName">{{ row.allName }}</td>
          <td mat-footer-cell *matFooterCellDef class="skeleton-footer-cell">
            <span class="skeleton-cell"></span>
          </td>
        </ng-container>
  
        <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
        <tr mat-footer-row *matFooterRowDef="displayedColumns"
            class="table-skeleton-row"
            [class.table-skeleton-hidden]="!isLoading"></tr>
      </table>
    </div>

    <app-pagination
      [isShowNoRecord]="!isLoading"
      (pageChange)="onChangePage($event)"
      [paginate]="paginate">
    </app-pagination>
  
    <p class="error-message" *ngIf="errorMessage">{{ errorMessage | translate }}</p>
  
    <div class="dialog-footer">
      <button mat-stroked-button color="primary" type="button" (click)="onCancel()">
        <mat-icon class="mr-0">cancel</mat-icon> {{ 'search_form_standardize.dialog_select_contract_review.btn_cancel' | translate }}
      </button>
      <button
      class="ml-2 btn-add-to-list"
        mat-raised-button
        color="primary"
        type="button"
        (click)="onAddToList()"
        [disabled]="!selectedCount || isSubmitting"
      >
        <mat-icon class="mr-0">check_circle</mat-icon> {{ 'search_form_standardize.dialog_select_contract_review.btn_submit' | translate }}
      </button>
    </div>
  </div>